<!-- <p>visitor-entry works!</p> -->
<section *ngIf="true" class="visitor-entry-wrapper">
  <div class="pdf-container">
    <div class="QR-header">Visitor QR Pass</div>
    <div class="QR-container">
      <qrcode
        [qrdata]="qrData"
        [allowEmptyString]="true"
        [ariaLabel]="'QR Code image with the following content...'"
        [cssClass]="'center'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [title]="'Visitor Invite Data'"
        [width]="300"
      ></qrcode>
    </div>
    <div class="visitor-details">
      <mat-grid-list cols="3" rowHeight="60px">
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">Name</div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            {{ visitorSecurityEPass.controls.firstName.value }}
            {{ visitorSecurityEPass.controls.lastName.value }}
          </div></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">Email</div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            {{ visitorSecurityEPass.controls.email.value }}
          </div></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">Phone Number</div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            {{ visitorSecurityEPass.controls.phone.value }}
          </div></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">Host Name</div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            {{ visitorSecurityEPass.controls.meeting.value }}
          </div></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">
            Visit Date & Time
          </div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            {{ visitDate | date }}
          </div></mat-grid-tile
        >
        <mat-grid-tile
          ><div class="mat-grid-tile-labels">
            Security Status
          </div></mat-grid-tile
        >
        <mat-grid-tile colspan="2"
          ><div class="mat-grid-tile-value">
            <button
              mat-raised-button
              [ngStyle]="
                !!this.securityStatus
                  ? { 'background-color': 'green' }
                  : { 'background-color': 'red' }
              "
            >
              {{ status }}
            </button>
          </div></mat-grid-tile
        >
        <mat-grid-tile colspan="3">
          <button
            [disabled]="!!this.securityStatus"
            (click)="onSubmitVisitorPassGuard()"
            mat-raised-button
          >
            Verify
          </button>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
</section>
